module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Cupboard-71623772615082a36b04f8f7a8588e8d.svg";